import applyTimezone from 'helpers/applyTimezone'
import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import FormControl from '@material-ui/core/FormControl'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import isEqual from 'lodash/isEqual'
import ClearIcon from '@material-ui/icons/Clear'
import moment from 'moment'
import {
  addDays,
  subDays,
  differenceInCalendarDays,
  differenceInMinutes,
  addMinutes,
} from 'date-fns'
import { connect } from 'react-redux'
import ProfileHelper from 'helpers/profile'
import { ReactComponent as EventIcon } from 'assets/img/ic_calendar.svg'
import { dateToLocalISO8601DateString } from 'helpers/dates'
import {
  EARLIER,
  EARLIER_OR_SAME,
  EQUAL,
  EQUAL_OR_HIGHER,
  EQUAL_OR_LOWER,
  HIGHER,
  LATER,
  LATER_OR_SAME,
  LOWER,
  SAME,
} from 'constants/index'
import cn from 'classnames'
import messages from '../translate'

export class JobDateInput extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: null,
      oldValue: null,
      evtTaskInputId: '',
      notificationMessage: '',
      isUpdating: false,
    }
  }

  componentDidMount() {
    const {
      inputData: { value = null, evtInputId },
    } = this.props

    this.setState({
      value,
      oldValue: value,
      evtTaskInputId: evtInputId,
    })
  }

  shouldComponentUpdate(nextProps) {
    const { inputInfo, inputData } = this.props
    const { inputInfo: nextInputInfo, inputData: nextInputData } = nextProps

    if (
      !isEqual(inputInfo, nextInputInfo) ||
      !isEqual(inputData, nextInputData)
    ) {
      const { value = null, evtInputId } = nextInputData
      // TODO remove after demo
      this.demoNotification(value)
      // TODO
      this.setState({
        value,
        oldValue: value,
        evtTaskInputId: evtInputId,
      })

      return false
    }

    return true
  }

  componentDidUpdate(prevProps, prevState) {
    const { oldValue: prevOldValue } = prevState
    const {
      inputInfo: {
        parameters: { lookup_table_source },
      },
      inputData: { value },
    } = this.props

    if (
      lookup_table_source &&
      (!lookup_table_source?.parents ||
        lookup_table_source?.parents?.length === 1) &&
      (!value || value !== prevOldValue)
    ) {
      const {
        index: inputId,
        inputs,
        dependency: { currentEvtTask, evtTaskMatches },
        activeJobId,
        handleDependentLookupInputs,
      } = this.props

      handleDependentLookupInputs(
        inputs,
        evtTaskMatches || [currentEvtTask],
        inputId,
        activeJobId,
      )
    }
  }

  componentWillUnmount() {
    const { isUnitBlockOpen } = this.props

    if (isUnitBlockOpen) {
      this.handleInputChange()
    }
  }

  setResultId = ({ id }) => {
    this.setState({ evtTaskInputId: id })
  }

  onDateChange = (value, invalidDate) => {
    const { dependency: { children } = {} } = this.props

    const validatedValue = value ? dateToLocalISO8601DateString(value) : value
    this.checkValidChildren(validatedValue, children)
    this.setState(
      {
        value: validatedValue,
      },
      () => {
        this.handleInputChange(invalidDate)
      },
    )
  }

  handleInputChange = invalidDate => {
    const {
      inputInfo,
      inputData: { evtInputId },
      onJobTaskAutoSave,
    } = this.props
    const { value, oldValue, evtTaskInputId } = this.state
    // TODO remove after demo
    this.demoNotification(value)
    // TODO
    if (value !== oldValue) {
      this.setState({
        isUpdating: true,
      })

      onJobTaskAutoSave(
        {
          evtInputId: invalidDate ? undefined : evtInputId || evtTaskInputId,
          result: value,
          input: inputInfo.id,
          setResultId: this.setResultId,
        },
        () => {
          this.setState({
            isUpdating: false,
          })
        },
      )

      this.setState({ oldValue: value })
    }
  }

  // TODO remove after demo
  demoNotification = value => {
    const {
      inputInfo: { workflow_input },
    } = this.props

    if (workflow_input && workflow_input === 89997) {
      let notificationMessage = ''
      const inputValue = this.dateStringToLocalDate(value)
      const today = new Date()
      if (inputValue && differenceInCalendarDays(inputValue, today) > 0) {
        notificationMessage =
          "Receiving date cannot be in the future. Please select today's date or an earlier one."
      }
      this.setState(() => ({ notificationMessage }))
    }

    if (workflow_input && workflow_input === 277897) {
      let notificationMessage = ''
      const { jobTask } = this.props
      const job = jobTask.toJS()
      const task = job?.tasks?.length ? job?.tasks[0] : null
      if (task) {
        const dependentInputId = task.input_items?.find(
          item => item.workflow_input === 277898,
        )?.id
        const evtTask = task.evt_tasks?.length ? task.evt_tasks[0] : null
        if (evtTask && dependentInputId) {
          const inputValue = this.dateStringToLocalDate(value)
          const dependentInputValue = evtTask.evt_inputs.find(
            evtInput => evtInput.input === dependentInputId,
          )?.result
          if (
            dependentInputValue &&
            differenceInCalendarDays(
              inputValue,
              this.dateStringToLocalDate(dependentInputValue),
            ) > 0
          ) {
            notificationMessage =
              'Load cannot\n' +
              'be received on a date later than the invoice date. Please update invoice date\n' +
              'or select today’s date/ an earlier one for received'
          }
        }
        this.setState(() => ({ notificationMessage }))
      }
    }
  }

  checkValidChildren = (value, children) => {
    const {
      dependency: {
        currentTaskID,
        currentEvtTask: { id: currentEvtTaskID },
      } = {},
      resetInvalidDates,
      clearCurrentTask,
    } = this.props
    const mainInputValue = this.dateStringToLocalDate(value)
    const invalidDates = []

    children.forEach(child => {
      const {
        id,
        result,
        parameters: { dependency: { rule } } = {},
        children,
      } = child
      let dependentValue = this.dateStringToLocalDate(result)
      let invalid = false

      switch (rule) {
        case HIGHER:
          dependentValue = subDays(dependentValue, 1)

          if (differenceInCalendarDays(mainInputValue, dependentValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case EQUAL_OR_HIGHER:
          if (differenceInCalendarDays(mainInputValue, dependentValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case EQUAL:
          if (
            differenceInCalendarDays(dependentValue, mainInputValue) > 0 ||
            differenceInCalendarDays(mainInputValue, dependentValue) > 0
          ) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case EQUAL_OR_LOWER:
          if (differenceInCalendarDays(dependentValue, mainInputValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case LATER:
          dependentValue = addMinutes(this.dateStringToLocalDateTime(result), 1)

          if (differenceInMinutes(mainInputValue, dependentValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case LATER_OR_SAME:
          if (
            differenceInMinutes(
              mainInputValue,
              this.dateStringToLocalDateTime(result),
            ) > 0
          ) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case SAME:
          if (
            differenceInMinutes(
              this.dateStringToLocalDateTime(result),
              mainInputValue,
            ) > 0 ||
            differenceInMinutes(
              mainInputValue,
              this.dateStringToLocalDateTime(result),
            ) > 0
          ) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case EARLIER_OR_SAME:
          if (
            differenceInMinutes(
              this.dateStringToLocalDateTime(result),
              mainInputValue,
            ) > 0
          ) {
            invalidDates.push(id)
            invalid = true
          }
          break
        case EARLIER:
          dependentValue = addMinutes(this.dateStringToLocalDateTime(result), 1)

          if (differenceInMinutes(dependentValue, mainInputValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
          break
        default:
          dependentValue = addDays(dependentValue, 1)

          if (differenceInCalendarDays(dependentValue, mainInputValue) > 0) {
            invalidDates.push(id)
            invalid = true
          }
      }

      if (!mainInputValue) {
        invalidDates.push(id)
      }

      if (invalid) {
        this.checkValidChildren('', children)
      }
    })

    if (invalidDates.length) {
      clearCurrentTask(invalidDates)
      resetInvalidDates({ invalidDates, currentTaskID, currentEvtTaskID })
    }
  }

  dateStringToLocalDate = s => {
    if (!s) return null

    return new DateFnsUtils().parse(s, 'yyyy-MM-dd')
  }

  dateStringToLocalDateTime = s => {
    if (!s) return null

    return new DateFnsUtils().parse(s, 'yyyy-MM-dd HH:mm:ss')
  }

  onInputFocus = e => {
    if (!e.target.value) {
      const { dependency: { children } = {}, site, licensee } = this.props
      const initialValue = applyTimezone(
        moment(),
        site?.timezone,
        licensee?.timezone,
      ).format('YYYY-MM-DD')

      this.checkValidChildren(initialValue, children)
      this.setState(
        {
          value: initialValue,
        },
        () => {
          this.handleInputChange(false)
        },
      )
    }
  }

  render() {
    const {
      disabled,
      className,
      inputInfo: {
        title,
        required,
        parameters: {
          dependency: { input, rule } = {},
          can_set_current_datetime,
        },
      },
      intl: { formatMessage },
      dependency: {
        dependency: { value: dependencyValue, title: dependencyTitle } = {},
      } = {},
      licensee: { usaDateFormat },
      inputHint,
    } = this.props
    const { value, isUpdating, notificationMessage } = this.state
    const locale = ProfileHelper.getCurrentLocale()
    const drawAsterisk = required ? '*' : ''
    const dependencyEmpty = input && dependencyValue === ''
    let message = ''
    let minDate
    let maxDate
    const parsedDate = this.dateStringToLocalDate(dependencyValue)
    const parsedValue = this.dateStringToLocalDate(value)
    let invalidDate = false
    const dateFormat = usaDateFormat ? 'MM-dd-yyyy' : 'dd-MM-yyyy'

    switch (rule) {
      case HIGHER:
        message = `${formatMessage(messages.shouldBeLater)} ${dependencyTitle}`
        minDate = addDays(parsedDate, 1)

        if (differenceInCalendarDays(minDate, parsedValue) > 0) {
          invalidDate = true
          minDate = parsedValue
        }
        break
      case EQUAL_OR_HIGHER:
        message = `${formatMessage(
          messages.shouldBeEqOrHigher,
        )} ${dependencyTitle}`
        minDate = parsedDate

        if (differenceInCalendarDays(minDate, parsedValue) > 0) {
          invalidDate = true
          minDate = parsedValue
        }
        break
      case EQUAL:
        message = `${formatMessage(messages.shouldBeEq)} ${dependencyTitle}`
        minDate = parsedDate
        maxDate = parsedDate

        if (differenceInCalendarDays(minDate, parsedValue) > 0) {
          invalidDate = true
          minDate = parsedValue
        }

        if (differenceInCalendarDays(parsedValue, maxDate) > 0) {
          invalidDate = true
          maxDate = parsedValue
        }
        break
      case EQUAL_OR_LOWER:
        message = `${formatMessage(
          messages.shouldBeEqOrLower,
        )} ${dependencyTitle}`
        maxDate = parsedDate

        if (differenceInCalendarDays(parsedValue, maxDate) > 0) {
          invalidDate = true
          maxDate = parsedValue
        }
        break
      case LOWER:
        message = `${formatMessage(messages.shouldBeLower)} ${dependencyTitle}`
        maxDate = subDays(parsedDate, 1)

        if (differenceInCalendarDays(parsedValue, maxDate) > 0) {
          invalidDate = true
          maxDate = parsedValue
        }
        break
      default:
    }

    const showHint = input && !invalidDate
    const isInputDisabled = disabled || isUpdating || dependencyEmpty

    return (
      <FormControl
        fullWidth
        className={cn(className, {
          warning: notificationMessage,
        })}>
        <span className="job-field-label">
          {title} {drawAsterisk}
        </span>
        <div className="job-field-wrapper">
          <EventIcon className="job-field-icon" />
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
            <DatePicker
              autoOk
              disableToolbar
              allowKeyboardControl={false}
              disabled={isInputDisabled}
              format={dateFormat}
              value={
                invalidDate ? this.dateStringToLocalDate(null) : parsedValue
              }
              onChange={value => {
                this.onDateChange(value, invalidDate)
              }}
              className="job-field-input-box"
              inputProps={{
                className: 'job-field-input',
                onFocus: can_set_current_datetime && this.onInputFocus,
              }}
              minDate={minDate}
              maxDate={maxDate}
            />
            {value && !isInputDisabled && (
              <ClearIcon
                className="job-field-icon job-field-clear-icon"
                onClick={e => {
                  e.preventDefault()
                  this.onDateChange(null, invalidDate)
                }}
              />
            )}
          </MuiPickersUtilsProvider>
        </div>
        {inputHint}
        {notificationMessage && (
          <span className="job-field-alert-text">{notificationMessage}</span>
        )}
        {showHint && (
          <span
            className={`job-field-alert-date-text${
              isInputDisabled ? '-disabled' : ''
            }`}>
            {message}
          </span>
        )}
        {invalidDate && (
          <span className="job-field-error-date-text">{message}</span>
        )}
      </FormControl>
    )
  }
}

export default connect(state => ({
  licensee: state.getIn(['profile', 'profile', 'licensee']),
  site: state.getIn(['profile', 'profile', 'site']),
  jobTask: state.getIn(['myJobs', 'jobTask']),
}))(injectIntl(JobDateInput))
